import { updateDiagramCluster as updateDiagramClusterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';


export async function updateDiagramCluster  (source) {
    const sleep = ms => new Promise(r => setTimeout(r, ms));
    await openProgressModal({status: 'Processing Clusters'})
    await sleep(50)
    updateDiagramClusterDiagram(source);
    closeProgressModal()

};

